import { types, applySnapshot, getSnapshot } from 'mobx-state-tree';
import { Transport } from 'modules/common/models/transport';
import { Notificator } from 'modules/common/models/notificator';
import { apiUrls } from 'modules/common/services/communication/urls';
import { flow } from 'modules/common/models/flow';
import { ProjectPortfolioDictionaryItem, ProjectPortfolioDictionaryItemType } from './project-portfolio';

export const ProjectPortfolioDictionary = types.compose(
    Transport, Notificator, types.model({
        portfolios: types.array(ProjectPortfolioDictionaryItem),
    }))
    .actions((self) => ({
        load: flow(function* (){
            try {
                const data: ProjectPortfolioDictionaryItemType[] = yield self.transport.get<any>(apiUrls.projectPortfolios.dictionary());
                // те же данные - узлы не трогаем: applySnapshot пересоздал бы их, а прежние
                // уже отданы компонентам (в dev React сравнивает старые пропсы и падает на
                // уничтоженном узле - страница сотрудников замирала с открытой карточкой)
                // сравниваем снимки: в ответе сервера бывают поля, которых нет в модели
                const next = getSnapshot(types.array(ProjectPortfolioDictionaryItem).create(data));
                if (JSON.stringify(getSnapshot(self.portfolios)) !== JSON.stringify(next)) {
                    applySnapshot(self.portfolios, next);
                }

                return true;
            } catch (er) {
                self.notify.error(er);
                return false;
            }
        })
    }))
    .views((self) => ({
        get isEmpty () {
            return !self.portfolios.length;
        }
    }))
    .named('ProjectPortfolioDictionary');

export const initialState = (): ProjectPortfolioDictionarySnapshotType => ({
    portfolios: []
});

export type ProjectPortfolioDictionaryType = typeof ProjectPortfolioDictionary.Type;
export type ProjectPortfolioDictionarySnapshotType = typeof ProjectPortfolioDictionary.SnapshotType;
